export default __webpack_public_path__ + "static/media/ma.c5e052e8.svg";